module.exports = __webpack_public_path__ + "img/icon-4.07b1f226.png";